import { render, staticRenderFns } from "./InfractionNoticesHeader.vue?vue&type=template&id=1088705a&"
import script from "./InfractionNoticesHeader.vue?vue&type=script&lang=js&"
export * from "./InfractionNoticesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports